import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPieReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 14,
	viewBox: "0 0 10 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.50001 3.5C3.25001 3.5 2.29001 4.61 2.53001 5.9C2.67001 6.68 3.32001 7.32 4.10001 7.47C5.40001 7.71 6.50001 6.75 6.50001 5.5H4.50001V3.5Z",
			stroke: "black",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 2.5V5.5H7.5C7.5 4.06 5.94 2.5 4.5 2.5Z",
			stroke: "black",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 0.5H0.5V13.5H9.5V0.5Z",
			stroke: "black",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 8V12",
			stroke: "black",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 9V12",
			stroke: "black",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 10V12",
			stroke: "black",
			strokeMiterlimit: 10
		})
	]
});
export default SvgPieReport;
